class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const totalProductsFilterCount = parseInt(count.match(/\d+/)[0], 10);
    const buttonCountContainer = document.querySelectorAll(
      ".mobile-facets__footer button"
    );
    buttonCountContainer.forEach((button) => {
      button.innerHTML = `SHOW ${totalProductsFilterCount} RESULTS`;
    });
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
    let collectionFacetsElem = document.querySelector(
      ".active-facets.active-facets-desktop"
    );
    if (collectionFacetsElem) {
      let activeFacetsLength = document.querySelectorAll(
        ".active-facets .active-facets__button-inner"
      ).length;

      if (activeFacetsLength > 0) {
        collectionFacetsElem.classList.add("open-facets-remove");
      } else {
        collectionFacetsElem.classList.remove("open-facets-remove");
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains("mobile-facets__details")
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if (document.querySelector(selector)) {
        document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
    function scrollToProductGrid() {
      let element = document.querySelector("#product-grid"); // Select the grid item

      let initialPosition;

      if (window.innerWidth >= 1100) {
        initialPosition = element.offsetTop + 450;
      } else {
        initialPosition = element.offsetTop + 250;
      }

      // Scroll to the position without any offset
      window.scrollTo({
        top: initialPosition,
        behavior: "smooth",
      });
    }

    scrollToProductGrid();
    // console.log("Filter Applied")
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }

    function extractNumber(str) {
      // Use regular expression to find digits in the string
      const match = str.match(/\d+/);
      if (match) {
        return parseInt(match[0], 10); // Convert the matched string to an integer
      } else {
        return 0; // Return 0 if no number is found
      }
    }

    const totalFilterCount = document.querySelectorAll(
      ".facets__selected.no-js-hidden.desktop"
    );
    let total = 0;

    totalFilterCount.forEach((count) => {
      const str = count.innerHTML;
      const number = extractNumber(str);
      console.log(number);
      total += number;
    });

    const filterCountElement = document.querySelectorAll(".filter-count");
    filterCountElement.forEach((element) => {
      element.innerHTML = total;
    });
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);

    // Check if we have price filters in sessionStorage and if they were explicitly selected
    try {
      const priceFiltersExplicitlySelected =
        sessionStorage.getItem("priceFiltersExplicitlySelected") === "true";

      if (priceFiltersExplicitlySelected) {
        const minPrice = sessionStorage.getItem("priceFilter_min");
        const maxPrice = sessionStorage.getItem("priceFilter_max");

        // Only include price parameters if they were explicitly selected
        if (minPrice && minPrice !== "0") {
          params.set("filter.v.price.gte", minPrice);
        }

        if (maxPrice) {
          params.set("filter.v.price.lte", maxPrice);
        }
      } else {
        // If price filters weren't explicitly selected, remove them from the URL
        params.delete("filter.v.price.gte");
        params.delete("filter.v.price.lte");
      }
    } catch (e) {
      console.error("Error handling price filters from sessionStorage:", e);
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    // Check if this is a "Clear all" button or a price filter removal
    const isClearAll = event.currentTarget.classList.contains(
      "active-facets__button-clear"
    );
    const isPriceFilter =
      event.currentTarget.dataset.facetName === "filter.v.price";

    // If clearing all filters or specifically clearing price filters, reset the sessionStorage
    if (isClearAll || isPriceFilter) {
      try {
        // Clear price filter values from sessionStorage
        sessionStorage.removeItem("priceFilter_min");
        sessionStorage.removeItem("priceFilter_max");
        sessionStorage.removeItem("priceFiltersExplicitlySelected");
      } catch (e) {
        console.error("Error clearing price filters from sessionStorage:", e);
      }
    }

    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    // Get all inputs (both range sliders and number inputs)
    this.inputs = this.querySelectorAll("input");

    // Get range sliders (first two inputs are range sliders)
    this.rangeInputs = Array.from(this.querySelectorAll('input[type="range"]'));

    // Get number inputs (for min and max price)
    this.numberInputs = Array.from(
      this.querySelectorAll('input[type="number"]')
    );

    // Add change event listeners to all inputs
    this.inputs.forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    // Add input event listeners to range sliders to update in real-time
    this.rangeInputs.forEach((slider, index) => {
      slider.addEventListener("input", this.onSliderInput.bind(this, index));
      // Add mouseup and touchend events to submit form when slider is released
      slider.addEventListener("mouseup", this.submitForm.bind(this));
      slider.addEventListener("touchend", this.submitForm.bind(this));
    });

    // Add input event listeners to number inputs to update sliders in real-time
    this.numberInputs.forEach((input, index) => {
      input.addEventListener("input", this.onNumberInput.bind(this, index));
    });

    // Initialize from sessionStorage if available
    this.initFromSessionStorage();

    this.setMinAndMaxValues();
  }

  // Initialize price values from sessionStorage
  initFromSessionStorage() {
    try {
      const storedMinPrice = sessionStorage.getItem("priceFilter_min");
      const storedMaxPrice = sessionStorage.getItem("priceFilter_max");

      if (storedMinPrice && this.numberInputs[0]) {
        this.numberInputs[0].value = storedMinPrice;
        if (this.rangeInputs[0]) {
          this.rangeInputs[0].value = storedMinPrice;
        }
      }

      if (storedMaxPrice && this.numberInputs[1]) {
        this.numberInputs[1].value = storedMaxPrice;
        if (this.rangeInputs[1]) {
          this.rangeInputs[1].value = storedMaxPrice;
        }
      }
    } catch (e) {
      console.error("Error initializing from sessionStorage:", e);
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  // Handle slider input events (when user is sliding)
  onSliderInput(index, event) {
    const slider = event.currentTarget;
    const value = Number(slider.value);

    // First slider controls min price, second slider controls max price
    if (index === 0 && this.numberInputs.length > 0) {
      // Update min price input
      this.numberInputs[0].value = value;
      // Store in sessionStorage
      try {
        sessionStorage.setItem("priceFilter_min", value.toString());
        sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
      } catch (e) {
        console.error("Error storing min price in sessionStorage:", e);
      }
    } else if (index === 1 && this.numberInputs.length > 1) {
      // Update max price input
      this.numberInputs[1].value = value;
      // Store in sessionStorage
      try {
        sessionStorage.setItem("priceFilter_max", value.toString());
        sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
      } catch (e) {
        console.error("Error storing max price in sessionStorage:", e);
      }
    }

    this.adjustToValidValues(slider);
    this.setMinAndMaxValues();
  }

  // Handle number input events (when user types in min/max price)
  onNumberInput(index, event) {
    const input = event.currentTarget;
    const value = Number(input.value);

    // First number input controls min price, second controls max price
    if (index === 0 && this.rangeInputs.length > 0) {
      // Update min price slider
      this.rangeInputs[0].value = value;
      // Store in sessionStorage
      try {
        sessionStorage.setItem("priceFilter_min", value.toString());
        sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
      } catch (e) {
        console.error("Error storing min price in sessionStorage:", e);
      }
    } else if (index === 1 && this.rangeInputs.length > 1) {
      // Update max price slider
      this.rangeInputs[1].value = value;
      // Store in sessionStorage
      try {
        sessionStorage.setItem("priceFilter_max", value.toString());
        sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
      } catch (e) {
        console.error("Error storing max price in sessionStorage:", e);
      }
    }

    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    // Handle constraints between range sliders
    if (this.rangeInputs.length >= 2) {
      const minSlider = this.rangeInputs[0];
      const maxSlider = this.rangeInputs[1];

      if (maxSlider.value) minSlider.setAttribute("max", maxSlider.value);
      if (minSlider.value) maxSlider.setAttribute("min", minSlider.value);
      if (minSlider.value === "") maxSlider.setAttribute("min", 0);
      if (maxSlider.value === "")
        minSlider.setAttribute("max", maxSlider.getAttribute("max"));
    }

    // Also ensure number inputs have correct min/max constraints
    if (this.numberInputs.length >= 2) {
      const minInput = this.numberInputs[0];
      const maxInput = this.numberInputs[1];

      if (maxInput.value) minInput.setAttribute("max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("min", 0);
      if (maxInput.value === "")
        minInput.setAttribute("max", minInput.getAttribute("max"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  // Submit the form when slider is released
  submitForm() {
    // Find the closest form
    const form = this.closest("form");
    if (form) {
      // Store current values in sessionStorage before submitting
      try {
        const minInput = this.numberInputs[0];
        const maxInput = this.numberInputs[1];

        if (minInput && minInput.value) {
          sessionStorage.setItem("priceFilter_min", minInput.value);
          sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
        }

        if (maxInput && maxInput.value) {
          sessionStorage.setItem("priceFilter_max", maxInput.value);
          sessionStorage.setItem("priceFiltersExplicitlySelected", "true");
        }
      } catch (e) {
        console.error("Error storing price values in sessionStorage:", e);
      }

      // Find the facet-filters-form element
      const facetFiltersForm = document.querySelector("facet-filters-form");
      if (
        facetFiltersForm &&
        typeof facetFiltersForm.onSubmitHandler === "function"
      ) {
        // Create a synthetic event to pass to the handler
        const event = new Event("submit");
        event.preventDefault = () => {}; // Add preventDefault method
        event.target = form; // Set the target to our form

        // Call the form submission handler
        setTimeout(() => {
          facetFiltersForm.onSubmitHandler(event);
        }, 100); // Small delay to ensure values are updated
      }
    }
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
    console.log("Cleared");

    let filterCountHeaderDesktop = document.querySelector(
      "#FacetsWrapperDesktop .filter-header .filter-count"
    );
    let filterShowResultsButton = document.querySelector(
      "button.no-js-hidden.button.button--primary.mobile__facets___button"
    );
    if (filterShowResultsButton) {
      filterShowResultsButton.innerHTML = "SHOW RESULTS";
    }
    if (filterCountHeaderDesktop) {
      filterCountHeaderDesktop.innerHTML = "0";
    }
  }
}

customElements.define("facet-remove", FacetRemove);
